import { http, HttpResponse } from 'msw';
import { mockTruktTmsApiUrl } from '../mocks';
import { CoupaGetFuelRatesResponse } from '../services/CoupaService';

export const handlers = [
  http.get(mockTruktTmsApiUrl('/coupa/fuel-rate'), () => {
    return HttpResponse.json<CoupaGetFuelRatesResponse>([
      {
        date: '2024-5-15',
        price: '100',
      },
      {
        date: '2024-5-1',
        price: '60.56',
      },
      {
        date: '2024-5-3',
        price: '123.45',
      },
    ]);
  }),
  http.put(mockTruktTmsApiUrl('/coupa/fuel-rate'), () => {
    return new HttpResponse(null, { status: 200 });
  }),
];
